import {Component, OnDestroy, OnInit} from '@angular/core';
import {fadeInRightAnimation} from '../../../@fury/animations/fade-in-right.animation';
import {scaleInAnimation} from '../../../@fury/animations/scale-in.animation';
import {fadeInUpAnimation} from '../../../@fury/animations/fade-in-up.animation';
import {Subject} from 'rxjs';
import {WebformService} from '../../services/reports/webform.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {ServerResponse} from '../../interfaces/base/server.response';
import {environment} from '../../../environments/environment';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'fury-received',
  templateUrl: './received.component.html',
  styleUrls: ['./received.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ReceivedComponent implements OnInit, OnDestroy {

  protected readonly environment = environment;

  public isLoading: boolean = true;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private titleService: Title,
              public webformService: WebformService,
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('Uw melding hebben wij in goede orde ontvangen - Milieu Klachten Centrale');

    if (this.webformService.report) {
      this.isLoading = false;
    } else {
      this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: Params): void => {
        if (typeof params['unique_number'] !== 'undefined') {
          if (params['unique_number'] !== null) {
            this.webformService.get(params['unique_number']).subscribe((response: ServerResponse): void => {
              if (typeof response !== 'undefined') {
                if (typeof response.data !== 'undefined') {
                  this.webformService.report = response.data;
                  this.isLoading = false;
                } else {
                  this.router.navigate(['/']).then((): void => {
                  });
                }
              } else {
                this.router.navigate(['/']).then((): void => {
                });
              }
            }, () => {
              this.isLoading = false;
            });
          } else {
            this.router.navigate(['/']).then((): void => {
            });
          }
        } else {
          this.router.navigate(['/']).then((): void => {
          });
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
